"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.subappRender = void 0;
const dynamicLoad_1 = require("../../dynamicLoad");
/**
 * Wraps the app in the providers and mounts it directly into the DOM
 */
const subappRender = async ({ id, entrypoint }) => {
    const config = {
        entrypoint,
        verticalId: id,
        reducers: {},
        wrapupConfig: {},
    };
    dynamicLoad_1.DynamicLoadManualStatic.leaveVerticalConfigAvailable(id, config);
};
exports.subappRender = subappRender;
//# sourceMappingURL=subapp.render.js.map